import { LayoutComponents } from "@jelly/lesson";

import * as multipleTones from "./tonality-hm/multiple-tones";
import * as singleTone from "./tonality-hm/single-tone";
import * as narrowBand from "./tonality-hm/narrow-band";
import * as recordedSound from "./tonality-hm/recorded-sound";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "controlsToggleExtraContent",
      options: {
        controlsPosition: "bottom",
        controls: [
          {
            type: "button",
            options: {},
            items: [
              { name: "Multiple Tones" },
              { name: "Single Tone with Broad-band Noise" },
              { name: "Narrow-Band Noise above Broad-band Noise" },
              { name: "Recorded Sound" },
            ],
          },
        ],
        extraContent: [
          multipleTones.extraContent,
          singleTone.extraContent,
          narrowBand.extraContent,
          recordedSound.extraContent,
        ],
        components: [multipleTones.components, singleTone.components, narrowBand.components, recordedSound.components],
      },
    },
  },
];

export default components;
